import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { width: "100%" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_object_config_component = _resolveComponent("object-config-component")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.params.header, (header, headerIdx) => {
          return (_openBlock(), _createElementBlock("th", { key: headerIdx }, _toDisplayString(header), 1))
        }), 128)),
        _createElementVNode("th", null, [
          (_ctx.field.params.template)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-transparent",
                title: "Add row to table",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
              }, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.ready)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.fieldOrder, (fieldName, fieldIdx) => {
            return (_openBlock(), _createBlock(_component_object_config_component, {
              key: fieldIdx,
              field: _ctx.field.children[fieldName],
              value: _ctx.modelValue.childValues[fieldName],
              "wrap-using-row": true,
              object: _ctx.object
            }, {
              buttons: _withCtx(() => [
                (_ctx.field.params.template)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-transparent",
                      title: "Remove row",
                      onClick: ($event: any) => (_ctx.removeRow(fieldIdx))
                    }, _hoisted_7, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["field", "value", "object"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}